// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconCalendarMark = createRemixIcon('IconCalendarMark', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16.75 2.75h-9.5V.5h-2.5v2.25h-4v20.5h22.5V2.75h-4V.5h-2.5zM3.25 9v11.75h17.5V9zm4.5 5.25h-2.5v-2.5h2.5zm0 4h-2.5v-2.5h2.5zm3-4h2.5v-2.5h-2.5zm8 0h-2.5v-2.5h2.5zm-8 4h2.5v-2.5h-2.5z\" clip-rule=\"evenodd\"/>");
